<template>
  <div>
    <div class="row mb-md-2 mt-2">
      <div class="col-sm-12 col-md-4">
        <div class="dataTables_length">
          <label class="d-inline-flex align-items-center dataTable_entries">
            <span >{{$t('common.show')}}</span>
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            ></b-form-select>
            <span >{{$t('common.entries')}}</span>
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="!model.length"
      class="text-center"
    >{{$t('user.form.empty_suitable_jobs')}}</div>

    <div
      v-for="(item, idx) in model"
      :key="idx"
      class="mt-2 h-100 bg-white" 
      style="border-radius: 10px; box-sizing: border-box; border-color: rgb(255, 255, 255); border-style: solid; margin: 5px; min-height: 141px; box-shadow: 0px 2px 5px rgba(19, 0, 0, 0.069); z-index: 3;"
    >
      <b-card class="shadow-none mb-0 p-1 applications-tab" no-body style="padding-inline: 20px; padding-bottom: 20px;">
        <div class="row justify-content-center">
          <div class="col-md-1 media pt-3">
            <Avatar :data="item" customSize="55" customFont="28" padding="2" />
          </div>
          <div class="col-md-10">
            <b-row align-h="between">
              <b-col class="pt-3">
                <span class="job-text-sm"> {{ item.company_id && item.company_id.name ? item.company_id.name : '-' }} </span>
                <div>
                  <span class="header">
                    <a4 class="job-text-md">{{ item.title }}</a4>
                  </span>
                </div>
              </b-col>
              <b-card-text class="pt-3">
              </b-card-text>
            </b-row>
            
            <b-row align-h="between">
              <b-col>
                <div style="font-size: 11px" v-if="item.updatedAt || item.createdAt">
                  {{ item.updatedAt ? 'Updated' : 'Created'}} {{ modifiedJobDate(item.updatedAt || item.createdAt) }}
                </div>
              </b-col>
            </b-row>

            <b-row align-h="between">
              <b-col class="small_text mt-3 text-truncate" style="max-height: 100px;">
                <button
                  class="custom-chip"
                  :class="`chip-status${item.status_type}`"
                >
                  <span><div class="icon-dot"/> {{ item.sub_status }}</span>
                </button>
              </b-col>
      
              <b-card-text class="header" style="font-size: 14px">
                {{ (item.min_salary ? item.min_salary.$numberDecimal : 0) || 0 | currency(item.currency_id.symbol, item.currency_id.symbol == '¥' ? 0 : 2)}}
                -
                {{ (item.max_salary ? item.max_salary.$numberDecimal : 0) || 0 | currency(item.currency_id.symbol, item.currency_id.symbol == '¥' ? 0 : 2)}}
              </b-card-text>
            </b-row>

            <b-row align-h="between">
              <div class="ml-2">
              </div>
            </b-row>

          </div>

        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment/moment'
import Avatar from '@components/avatar'

export default {
  components: { Avatar },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    applicationData() {
      let model = this.model || []
      return model.slice(0, this.perPage) || []
    }
  },
  data() {
    return {
      perPage: 20,
			pageOptions: [20, 50, 100, 200],
      currentPage: 1,
      sortBy: 'date_created',
			sortDesc: true,
      model: []
    }
  },
  methods: {
    fetchData(data) {
      let applications = data || []
      this.model = applications.map( res => {
        let job = { ...res.job_id }
        job.sub_status = res['sub_status'] ? res.sub_status : 'Shortlisted'
        job.status_type = res.status_type
        return { ...job }
      })
    },
    modifiedJobDate(date) {
      return date ? moment(date).format('YYYY-MM-DD hh:mm:ss A') : '-'
    },
  }
  
}
</script>

<style lang="scss">
  .applications-tab {
    color: #030013;
    opacity: 0.8;
  }

  .badge-matched {
    background-color: rgba(235, 47, 91, 0.2);
    color: #EB2F5B;
    // width: 89px;
    height: 20px;
    // display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 2px 8px;
    gap: 12px;
  }
</style>